<template>
	<div class="d-flex align-items-center justify-content-between">
		<label class="form-label mb-2 tv-bold">{{ pll["Calculate in"] }}</label>
		<custom_select 
			data-name="currency_out"
			:data-value="currency_out"
			class="simple-btn select__analytics" v-model="currency_out" :options="$store.state.currencies_list"
		/>
	</div>
</template>
<script>
import custom_select from "./custom_select";

export default {
	components: {
		custom_select,
	},
	props: {
		currency: {
			required: false,
			default: "EUR"
		}
	},
	data() {
		return {
			currency_out: null,
		};
	},
	beforeMount() {
		this.currency_out = this.currency;
		this.$store.commit("currency_output", this.currency_out);
	},
	watch: {
		currency_out(val) {
			this.$store.commit("currency_output", val);
		},
	},
};
</script>
